import React from "react";
import { buildQaLabel } from "@tvg/test-utils/utils";
import { HighlightedStyle } from "@tvg/ts-types/Race";
import { TrackNameDisplay } from "../TrackNameDisplay";
import { Container, Block } from "./styled-components";
import { TrackLocationDisplay } from "../TrackLocationDisplay";
import { type HeaderProps } from "./types";
import { Mtp } from "../Mtp";
import { RaceIcons } from "../RaceIcons";
import { LOCATION } from "../../utils/constants";

export const Header = ({
  race,
  qaLabel,
  isLocationDisplayed,
  isRaceNumberOnSameLine,
  onClick
}: HeaderProps) => {
  const hasDescription = !!race?.highlighted?.description;
  const isHighlighted =
    race?.highlighted?.style === HighlightedStyle.Highlighted;

  return (
    <Container
      data-qa-label={qaLabel}
      hasDescription={hasDescription}
      isHighlighted={isHighlighted}
      onClick={onClick}
    >
      <TrackNameDisplay
        raceName={race.track.name}
        raceNumber={race.raceNumber || race.number}
        raceHighlightedDescription={race.highlighted?.description}
        isHighlighted={isHighlighted}
        qaLabel={qaLabel}
        isRaceNumberOnSameLine={isRaceNumberOnSameLine}
      />
      {isLocationDisplayed ? (
        <TrackLocationDisplay race={race} qaLabel={qaLabel} />
      ) : (
        <Block>
          <Mtp
            qaLabel="qp-header-mtp"
            mtp={race.mtp}
            postTime={race.postTime}
            status={race.status.code}
            size="xs"
            mode={isHighlighted ? "dark" : "light"}
          />
          <RaceIcons race={race} qaLabel={buildQaLabel([qaLabel, LOCATION])} />
        </Block>
      )}
    </Container>
  );
};

export default Header;
